import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import {
    toggle,
    cardToggleArray,
    eventRow,
    eventNumber,
    activeFAQ,
    initFAQ,
    PagesAsync,
    pagesData,
    FAQsAsync,
    bannerData
} from './function';


export function FAQs() {
    const cardArray = useSelector(cardToggleArray);
    const eventNum = parseInt(useSelector(eventNumber));
    const eventrow = parseInt(useSelector(eventRow));
    const pages_Data = useSelector(pagesData);
    const banner_Data = useSelector(bannerData);
    const dispatch = useDispatch()

    const getBannerStyle = (webImage, mobileImage) => ({
        backgroundImage: window.matchMedia('screen and (max-width: 575.98px)').matches ? 'url(' + mobileImage + ')' : 'url(' + webImage + ')'
    });
    
    useEffect(() => {
        dispatch(FAQsAsync());
        dispatch(PagesAsync());
        var hash = window.location.hash ? parseInt(window.location.hash.replaceAll('#FAQ', '')) : 0;
        dispatch(initFAQ(hash));
    }, []);

    
    // onLoad={dispatch(toggle(hash))}
    return (
        <section id="FAQs" >
            {/* <div className="container-fluid content-wrapper position-relative section-1">
                <div className="container">
                    <div className="row ">
                        <div className="col-md-12 banner-box w-100">
                            <div className="box text-center">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="position-absolute bg-flush w-100 h-100 top-0 left-0 pt-5 d-flex align-items-center justify-content-start">
                    <div className="container">
                        <div className="row ">
                            <div className="col-md-12">
                                <p className="text-light d-flex align-items-center">Home <span className="material-icons">chevron_right</span></p>
                                <h1 className="theme-font-color font-weight-bold m-0">FAQs</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="position-absolute" style={{ right: 15, bottom: 10 }}>
                    <small className="text-light"><i>*Photo was taken before COVID-19</i></small>
                </div>
            </div> */}
            {banner_Data && banner_Data.modules.map((data, index) => {
                if (data.type === 'Banner') {
                    return (
                        <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                            {data.data.map((child, child_index) => {
                                return (
                                    <div key={child_index} className={'container-fluid content-wrapper position-relative ' + data.type} style={getBannerStyle(child.imageWeb, child.imageMobile)}>
                                        <div className="container">
                                            <div className="row ">
                                                <div className="col-md-12 banner-box w-100">
                                                    <div className="box text-center">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="position-absolute bg-flush w-100 h-100 top-0 left-0 pt-5 d-flex align-items-center justify-content-start">
                                            <div className="container">
                                                <div className="row ">
                                                    <div className="col-md-12">
                                                        <p className="text-light d-flex align-items-center">Home <span className="material-icons">chevron_right</span></p>
                                                        <h1 className="theme-font-color font-weight-bold m-0">{child.title}</h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="position-absolute" style={{ right: 15, bottom: 10 }}>
                                            {child.caption && <small className="text-light"><i>*{child.caption}</i></small>}
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    )
                }
            })
            }
            <div className="container-fluid section-2 position-relative section-spacing-topdown">
                <div className="container">
                    {pages_Data && pages_Data.map((data, index) => {
                        return (
                            <div key={index} id={'FAQ'+(index+1)} className="row mb-4">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header py-3 d-flex justify-content-between" onClick={() => dispatch(toggle(index))}>
                                            <div className="d-flex align-items-center">
                                                {data.title}
                                            </div>
                                            <div>
                                                <img src={cardArray[index] ? 'images/faqs/Big Minus.svg' : 'images/faqs/Big Plus.svg'} alt="" />
                                            </div>
                                        </div>
                                        {cardArray[index] && <div className="card-body">
                                            <Accordion  onSelect={(AccordionIndex) => dispatch(activeFAQ(index, AccordionIndex))}>
                                                {data.faQs.slice().sort((c, d) => (c.sequence > d.sequence) ? 1 : -1).map((child, child_index) => {
                                                    return (
                                                        <div key={child_index} className="accordion-item overflow-auto">
                                                            <p className="accordion-header m-0">
                                                                <Accordion.Toggle className="accordion-button" eventKey={child_index.toString()}>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <div>{child.question}</div>
                                                                        <div><img src={eventNum === child_index && eventrow === index ? 'images/faqs/Minus.svg' : 'images/faqs/Plus.svg'} alt="" /></div>
                                                                    </div>
                                                                </Accordion.Toggle>
                                                            </p>
                                                            <Accordion.Collapse eventKey={child_index.toString()}>
                                                                <div className="accordion-body p-2" dangerouslySetInnerHTML={{ __html: child.answer }}></div>
                                                            </Accordion.Collapse>
                                                        </div>
                                                    )
                                                })
                                                }
                                            </Accordion>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        )
                    })
                    }
                </div>
            </div>
        </section>
    );
}

